module.exports = __webpack_public_path__ + "img/6d677a3.svg";